import { useSelector } from "react-redux";
import React from "react";
import { Paper, Typography, Box } from "@mui/material";

const Portfolio_Highlights = () => {
  const portfolioTotalValue = useSelector(
    (state) => state.portfolio?.data?.portfolio_topline?.[0]?.portfolio_total_value || 0
  );
  const demoMode = useSelector((state) => state.demoMode?.isDemoMode);
  const portfolioAlertsCount = useSelector(
    (state) => state.portfolio?.data?.pf_data_alert?.length ?? 0
  );
  const favoriteAlertsCount = useSelector(
    (state) => state.favorites?.data?.favorites_alert_data?.length ?? 0
  );
  const opportunitiesAlertsCount = useSelector(
    (state) => state.portfolio?.data?.opportunities_alerts?.length ?? 0
  );

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.1,
        width: "100%",
        height: "100%",
        backgroundColor: "transparent",
        boxShadow: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        overflow: "hidden",
      }}
    >
      <Typography
        noWrap
        sx={{
          fontSize: "0.6rem",
          fontWeight: 600,
          mb: 0.0,
          lineHeight: 0.9,
        }}
      >
        Quick Stats
      </Typography>

      <Box display="flex" flexDirection="column" gap={0.0} sx={{ overflow: "hidden" }}>
        <HighlightRow label="Total Value:" value={`$${parseFloat(portfolioTotalValue).toLocaleString()}`} blur={demoMode} />
        <HighlightRow label="Portfolio Alerts:" value={portfolioAlertsCount} />
        <HighlightRow label="Favorite Alerts:" value={favoriteAlertsCount} />
        <HighlightRow label="Opportunities Alerts:" value={opportunitiesAlertsCount} />
      </Box>
    </Paper>
  );
};

const HighlightRow = ({ label, value, blur }) => (
  <Box
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    alignItems="center"
    width="100%"
    sx={{
      overflow: 'hidden',
    }}
  >
    <Typography
      sx={{
        fontSize: '0.5rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
      }}
    >
      {label}
    </Typography>

    <Typography
      sx={{
        fontSize: '0.5rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flexShrink: 0,
        ...(blur ? { filter: 'blur(3px)' } : {}),
      }}
    >
      {value}
    </Typography>
  </Box>
);



export default Portfolio_Highlights;
